import React, { useEffect, useRef, useState } from 'react';
import { subscribeToasts } from '../../utils/toast';

const variantStyles = {
  success: {
    container: 'border-emerald-200 bg-emerald-50 text-emerald-900 shadow-emerald-100',
    accent: 'bg-emerald-500',
    icon: '✓',
  },
  error: {
    container: 'border-rose-200 bg-rose-50 text-rose-900 shadow-rose-100',
    accent: 'bg-rose-500',
    icon: '!',
  },
  warning: {
    container: 'border-amber-200 bg-amber-50 text-amber-900 shadow-amber-100',
    accent: 'bg-amber-500',
    icon: '!',
  },
  info: {
    container: 'border-sky-200 bg-sky-50 text-sky-900 shadow-sky-100',
    accent: 'bg-sky-500',
    icon: 'i',
  },
};

export default function ToastViewport() {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef(new Map());

  useEffect(() => {
    const unsubscribe = subscribeToasts((toastItem) => {
      setToasts((current) => [...current, toastItem]);
    });

    return () => {
      unsubscribe();
      timersRef.current.forEach((timerId) => clearTimeout(timerId));
      timersRef.current.clear();
    };
  }, []);

  useEffect(() => {
    toasts.forEach((toastItem) => {
      if (timersRef.current.has(toastItem.id)) {
        return;
      }

      const timerId = window.setTimeout(() => {
        setToasts((current) => current.filter((entry) => entry.id !== toastItem.id));
        timersRef.current.delete(toastItem.id);
      }, toastItem.duration || 3500);

      timersRef.current.set(toastItem.id, timerId);
    });
  }, [toasts]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[9999] flex w-full max-w-sm flex-col gap-3 px-2 sm:right-6 sm:top-6 sm:px-0">
      {toasts.map((toastItem) => {
        const styles = variantStyles[toastItem.type] || variantStyles.info;

        return (
          <div
            key={toastItem.id}
            role="status"
            aria-live="polite"
            className={`pointer-events-auto overflow-hidden rounded-2xl border ${styles.container} shadow-lg transition-all duration-200 ease-out`}
          >
            <div className={`h-1 w-full ${styles.accent}`} />
            <div className="flex items-start gap-3 px-4 py-3">
              <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${styles.accent}`}>
                {styles.icon}
              </div>
              <p className="flex-1 pt-0.5 text-sm font-medium leading-5">{toastItem.message}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}